<template>
  <div>
    <div @click="showPopup" class="cursor-pointer">
      <slot></slot>
    </div>
    <portal to="popup">
      <transition name="just-fade">
        <div
          class="fixed z-50 popup-background pin flex justify-center items-start md:items-center p-8"
          v-if="open"
        >
          <div
            class="white-card content w-full max-w-lg relative pt-12"
            v-click-outside="hidePopup"
          >
            <a class="absolute pin-t pin-r cursor-pointer mr-4 mt-4" @click="hidePopup">
              <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="h-6 w-6"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>
            </a>
            <slot name="popup"></slot>
          </div>
        </div>
      </transition>
    </portal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false
    };
  },
  methods: {
    showPopup() {
      this.open = true;
    },
    hidePopup() {
      this.open = false;
    }
  }
};
</script>

<style></style>
